import React from 'react';

import S from './Mail.module.css';

export const MailImg = () => (
  <div className={S.root}>
    <div className={S.mail}>
      <div className={S.mailTop}></div>
      <div className={S.mailBottom}></div>
    </div>
    <div className={S.clouds}>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
    </div>
    <div className={S.clouds2}>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
      <b></b>
    </div>
  </div>
);
